import React, { useState } from 'react';
import { api, resolveImg } from '../../lib/api';
import { Upload, Loader2, X } from 'lucide-react';

const ImageUpload = ({ value, onChange, label = 'Image' }) => {
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append('file', file);
    try {
      const { data } = await api.post('/admin/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      onChange(data.url);
    } catch (err) {
      alert('Upload failed. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <span className="text-sm font-medium text-ktc-charcoal/80">{label}</span>
      <div className="mt-1.5 flex items-center gap-4">
        <div className="h-20 w-20 rounded-lg border border-ktc-cream bg-ktc-cream/40 overflow-hidden grid place-items-center shrink-0">
          {value ? (
            <img src={resolveImg(value)} alt="preview" className="h-full w-full object-cover" />
          ) : (
            <Upload size={20} className="text-ktc-charcoal/40" />
          )}
        </div>
        <div className="flex-1">
          <label className="inline-flex items-center gap-2 bg-ktc-green hover:bg-ktc-greenLight text-ktc-ivory text-sm font-medium px-4 py-2.5 rounded-md cursor-pointer transition-colors">
            {busy ? <Loader2 size={16} className="animate-spin" /> : <Upload size={16} />} Upload image
            <input type="file" accept="image/*" className="hidden" onChange={handle} disabled={busy} />
          </label>
          {value && (
            <button type="button" onClick={() => onChange('')} className="ml-3 text-xs text-red-600 inline-flex items-center gap-1"><X size={13} /> Remove</button>
          )}
          <p className="text-xs text-ktc-charcoal/45 mt-1.5 break-all">{value || 'No image selected'}</p>
        </div>
      </div>
    </div>
  );
};

export default ImageUpload;
